/* Chart utilities copied from c2Archive/charts.js */

// site-wide default for bar width. If series don't specify maxPointWidth, this will be used.
var globalMaxPointWidth = 40;


(function (c2, $, _, Highcharts) {
  'use strict';

    // default export menu items
  var exportingOptions = {
    filename: 'Date-wise Cost Details',
    toCSV: function(values) {
      let headers = [];
      let all_values = [];
      all_values = getAllValues(values);
      let name = all_values.name;
      let usage_date = all_values.usage_date;
      let cost = all_values.cost;
      let graphType = all_values.graphType;
      if (graphType == "Group"){
        headers = ['Resource Handler', 'UsageDate', 'Cost']
      }
      else if(graphType == "Server"){
        headers = ['Type', 'UsageDate', 'Cost']
      }

      return c2.downloads.arrayToCSV(
        headers, _.zip(name, usage_date, cost));
    },
    buttons: {
      contextButton: {
        menuItems: [
          {
            text: gettext('Print'),
            onclick: function() {
              this.print();
            }
          },
          { separator: true },
          {
            text: gettext('Export as PNG Image'),
            onclick: function() {
              exportChartAsPNG(this, this.options.exporting.filename + '.png');
            }
          },
          {
            text: gettext('Export as CSV'),
            onclick: function() {
              // The report configuration defines toCSV, a non-standard
              // Highcharts option, so that this handler remains generic.
              c2.downloads.startDownloadFromContent(
                this.options.exporting.toCSV(this.series),
                this.options.exporting.filename + '.csv');
            }
          }
        ]
      }
    }
  };

  var serverBarChartDefaults = {
    subtitle: {
      text: gettext('Includes all servers in groups you have permission to view.')
    },
    yAxis: {
      title: { text: gettext('Number of Servers') }
    },
    series: [
      {
        name: gettext('Servers'),
        maxPointWidth: 40,
      }
    ],
    chart: {
      type: 'bar'
    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true
        }
      }
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.y}</b>'
    },
    legend: {
      enabled: false
    },
    credits: {
      enabled: false
    },
    exporting: exportingOptions
  };


    /**
   * This method gets the SVG of the chart and uses canvg to draw it on a
   * HTML5 canvas. The canvas is then streamed to the browser window as a
   * download. Replaces a server-side solution for chart export.
   * http://www.highcharts.com/docs/export-module/export-module-overview
   */
  function exportChartAsPNG(chart) {
    var svg = chart.getSVG(),
        width = parseInt(svg.match(/width="([0-9]+)"/)[1]),
        height = parseInt(svg.match(/height="([0-9]+)"/)[1]),
        canvas = document.createElement('canvas');

    canvas.setAttribute('width', width);
    canvas.setAttribute('height', height);

    if (canvas.getContext && canvas.getContext('2d')) {
      canvg(canvas, svg);
      c2.downloads.startDownload(
        canvas.toDataURL("image/png"),
        chart.options.exporting.filename + '.png'
      );
    } else {
      alert ("Your browser doesn't support this feature. Please use a " +
             "modern browser that supports the canvas element.");
    }
  }


  /* Make monochrome colors and set them as default for all pies
   *
   * Start with slightly darker than base, end with much brighter.
   */
  function distributeMonochromePieColors(categoryCount) {
    Highcharts.getOptions().plotOptions.pie.colors = (function () {
      var colors = [],
          base = Highcharts.getOptions().colors[0],
          i, b,
          start = -0.2,
          end = 0.4,
          step = categoryCount ? ((end - start) / categoryCount) : 1;

      for (i = 0, b = start; i < categoryCount; i += 1, b += step) {
        colors.push(Highcharts.Color(base).brighten(b).get());
      }
      return colors;
    }());

    // Return colors in case the caller wants these
    return Highcharts.getOptions().plotOptions.pie.colors;
  }


  function bar($elem, options) {
    var barDefaults = serverBarChartDefaults;

    $elem.highcharts(_.merge(barDefaults, options));
  }


  /**
    * Bar chart on the Storage Report.
    * Given an array of arrays representing the visible datatable contents,
    * draw a bar chart of each server's storage. This data is taken directly
    * from the datatable.
    */
  function drawStorageChart(rows) {

      var hostnameColumn = 1;
      var storageColumn = 2;

      var categories = [],
          storageSizes = [],
          hostname;

      _.forEach(rows, function(row){
          // Hostname column contains hidden hostname and other HTML; extract
          // the actual hostname
          hostname = $(row[hostnameColumn]).find('.hostname').text();
          categories.push(hostname);
          storageSizes.push(row[storageColumn]);
      });

      var heightPx = 400;
      if (categories.length > 25) {
          heightPx = 600;
      }

      $('#chart_div')
          .highcharts(_.merge(c2.charts.serverBarChartDefaults, {
              chart: {
                  height: heightPx
              },
              plotOptions: {
                series: {
                  animation: false
                }
              },
              title: {
                  text: gettext('Servers by storage')
              },
              xAxis: {
                  categories: categories
              },
              yAxis: {
                  title: { text: gettext('Storage in GB') }
              },
              series: [
                  {
                      name: gettext('Storage in GB'),
                      data: storageSizes
                  }
              ],
              exporting: {
                  enabled: false
              }
          }));
  }

  function getCategoriesAsDates(categories) {
    var dates = [];
    for (var i = 0; i < categories.length; i++) {
      dates[i] = new Date(categories[i]);
    }
    return dates;
  }

  function buildSeriesFromObject(valuesBySeriesName, type) {
    var series = [];
    var n = 0;
    for (var name in valuesBySeriesName) {
      var values = valuesBySeriesName[name];
      series[n] = {
        name: name,
        type: type,
        marker: {enabled: false},
        data: (function(vals) {
          var points = [];
          for (var i = 0; i < vals.length; i++) {
            points.push({x: i, y: vals[i], graphType: 'Group'});
          }
          return points;
        }(values))
      };
      n++;
    }
    return series;
  }

  // Kept in sync with vue3/src/components/common/highcharts/theme.js DarkTheme
  var darkTheme = {
    chart: {
      backgroundColor: 'none'
    },
    title: {
      style: {
        color: '#F0F0F0',
      }
    },
    subtitle: {
      style: {
        color: '#bfbcbc'
      }
    },
    xAxis: {
      gridLineColor: '#6d6c6c',
      gridLineWidth: 1,
      labels: {
        style: {
          color: '#F0F0F0'
        }
      },
      lineColor: '#A0A0A0',
      tickColor: '#A0A0A0',
      title: {
        style: {
          color: '#A0A0A0'
        },
      }
    },
    yAxis: {
      gridLineColor: '#6d6c6c',
      labels: {
        style: {
          color: '#F0F0F0'
        }
      },
      lineColor: '#A0A0A0',
      tickColor: '#A0A0A0',
      tickWidth: 1,
      title: {
        style: {
          color: '#A0A0A0',
        }
      }
    },
    legend: {
      itemStyle: {
        color: '#F0F0F0'
      },
      itemHoverStyle: {
        color: '#F0F0F0'
      },
      itemHiddenStyle: {
        color: '#6d6c6c'
      }
    },
    tooltip: {
      backgroundColor: 'rgba(0, 0, 0, 0.85)',
      style: {
        color: '#F0F0F0'
      },
      borderRadius: 5,
    },
    plotOptions: {
      line: {
        dataLabels: {
          color: '#CCC'
        },
        marker: {
          lineColor: '#4e4e4e'
        }
      },
      series: {
        dataLabels: {
          style: {
            color: '#CCC'
          }
        }
      },
      pie: {
        borderColor: '#333',
        borderWidth: 1,
      },
      scatter: {
        marker: {
          lineColor: '#4e4e4e'
        }
      },
    },
    labels: {
      style: {
        color: '#CCC'
      }
    },
    noData: {
      style: {
        color: '#C0C0C0'
      }
    },
    // Non-standard keys (not consumed by Highcharts itself) — chart-specific
    // JS reads these off Highcharts.getOptions() to color labels/masks in a
    // few report widgets. Keep the same three keys mirrored in
    // vue3/src/components/common/highcharts/theme.js.
    dataLabelsColor: '#444',
    textColor: '#C0C0C0',
    maskColor: 'rgba(255,255,255,0.3)'
  };

  function applyDarkTheme() {
    Highcharts.theme = darkTheme;
    Highcharts.setOptions(Highcharts.theme);
  }

  var billingSeriesDefaults = {
    title: {text: ''},
    yAxis: {
      labels: {format: '${value:.2f}'},
      title: {text: 'Cost (USD)'}
    },
    xAxis: {
      type: 'datetime',
      tickInterval: 5,
      labels: {format: '{value:%e %b %Y}'}
    },
    tooltip: {
      headerFormat: '<b>{point.x:%e %b %Y}</b> <br>',
      pointFormat: '{series.name}: <b>${point.y:.2f}</b>'
    },
    series: {type: 'spline'},
    credits: {enabled: false},
    exporting: exportingOptions,
    chart: {zoomType: 'xy'}
  };

  function pie($elem, options) {
    var pieDefaults = {
      plotOptions: {
        chart: {type: 'pie'},
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            color: '#000000',
            connectorColor: '#000000',
            formatter: function() {
              return '<b>' + this.point.name + '</b>: ' + this.point.y;
            }
          },
          shadow: false
        }
      },
      tooltip: {pointFormat: '{series.name}: <b>{point.percentage:.1f} %</b>'},
      yAxis: {title: {text: 'Total percent'}},
      legend: {enabled: false},
      credits: {enabled: false},
      exporting: exportingOptions
    };
    $elem.highcharts(_.merge(pieDefaults, options));
  }

  // Vary chart container height based on number of categories.
  // Intended for charts with horizontal bars.
  function containerHeight(numCategories) {
      var pxPerCategory;

      // Slightly more dense layout as the number of categories increases.
      if (numCategories < 40) {
          pxPerCategory = 30; // Nice and spacious, max 1200px high
      } else {
          if (numCategories < 80) {
          pxPerCategory = 20; // More compact and max 1600px high
          } else {
          pxPerCategory = 15; // Very compact and no max height
          }
      }

      var minContainerHeight = 400;
      var containerHeight = pxPerCategory * numCategories;
      if (containerHeight < minContainerHeight) {
          containerHeight = minContainerHeight;
      }

      return containerHeight;
  }

// expose public functions
c2.charts = {
  exportChartAsPNG: exportChartAsPNG,
  serverBarChartDefaults: serverBarChartDefaults,
  billingSeriesDefaults: billingSeriesDefaults,
  darkTheme: darkTheme,
  applyDarkTheme: applyDarkTheme,
  distributeMonochromePieColors: distributeMonochromePieColors,
  drawStorageChart: drawStorageChart,
  bar: bar,
  pie: pie,
  containerHeight: containerHeight,
  getCategoriesAsDates: getCategoriesAsDates,
  buildSeriesFromObject: buildSeriesFromObject,
  // There's at least 1 case where we only want to use the exporting options, not all of the defaults
  exportingOptions: exportingOptions
};

})(window.c2, window.$, window._, window.Highcharts);
